import React, { Component } from "react";

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
  } from "react-router-dom";

import {AuthContext} from 'auth_context';
import TermsOfService from 'pages/tos';
import PrivacyPolicy from "pages/privacy_policy";
import AboutUs from 'pages/about_us';
import ScrollToTop from "pages/scroll_to_top";
import Review from 'pages/review';
import Account from 'pages/account';
import Login from 'pages/login';
import AdsLanding from "pages/ads_landing";
import AgentFavoriteVendorList from "pages/agents/agent_favorite_vendor_list";
import AgentContacts from "pages/agents/agent_contacts";
import AgentIndex from "pages/agents/agent_index";
import AgentLanding from "pages/agents/agent_landing";
import VendorDetail from "pages/agents/vendor_detail";
import PasswordReset from "pages/password_reset";
import VendorReview from "pages/agents/vendor_review";
import PropertyInspector from "pages/agents/property_inspector";
import AgentFriends from "pages/agents/agent_friends";
import AgentFriendsSearch from "pages/agents/agent_friends_search";
import VendorSearch from "pages/agents/vendor_search";
import VendorDiscover from "pages/agents/vendor_discover";
import SignUp from "pages/code_guide/sign_up";
import ContactIndex from "pages/agents/contact_index";
import ContactVendorList from "pages/agents/contact_vendor_list";
import IndexNew from "pages/index_new";
import GmailImport from "pages/agents/gmail_import";
import Header from "pages/header";
import Footer from "pages/footer";
import ReviewEmailConfirmation from "pages/review_email_confirmation";
import Authentication from "pages/authentication";
import Guides from "pages/guides";
import ReplaceKitchenAppliances from "pages/guides/replace_kitchen_appliances";
import ReplaceKitchenBacksplash from "pages/guides/replace_kitchen_backsplash";
import ReplaceKitchenCountertop from "pages/guides/replace_kitchen_countertop";
import ContactLogin from "pages/agents/contact_login";
import PermitsAdmin from "pages/permits_admin";
import Video from "pages/video";
import Tutorials from "pages/tutorials";
import SignUpVideo from "pages/sign_up_video";
import VendorPlans from "pages/vendors/vendor_plans";
import VendorIndex from "pages/vendors/vendor_index";
import VendorAccount from "pages/vendors/vendor_account";
import VendorRequests from "pages/vendors/vendor_requests";
import VettedVendors from "pages/agents/vetted_vendors";
import CodeLanding from "pages/code_guide/code_landing";
import SfPlanningDetail from "pages/code_guide/sf_planning_detail";
import SfPlanningInsights from "pages/code_guide/sf_planning_insights";
import OakPlanningSearch from "pages/code_guide/oak_planning_search";
import OakPlanningDetail from "pages/code_guide/oak_planning_detail";
import SfPlanningAdmin from "pages/code_guide/sf_planning_admin";
import OakPlanningAdmin from "pages/code_guide/oak_planning_admin";
import JbkPlanningAdmin from "pages/code_guide/jbk_planning_admin";
import JbkPlanningSearch from "pages/code_guide/jbk_planning_search";
import JbkPlanningDetail from "pages/code_guide/jbk_planning_detail";
import CodeParts from "pages/code_guide/code_parts";
import CodeLabels from "pages/code_guide/code_labels";
import CodeTables from "pages/code_guide/code_tables";
import CodeSections from "pages/code_guide/code_sections";
import CodeZoning from "pages/code_guide/code_zoning";
import Assistant from "pages/assistant/contact_index";
import CodeSearch from "pages/code_guide/code_search";
import SfPlanningSearchV2 from "pages/code_guide/sf_planning_search_v2";
import SfPlanningDetailV2 from "pages/code_guide/sf_planning_detail_v2";
import SkuMetadataList from "pages/amz/sku_metadata_list";
import SkuMetadata from "pages/amz/sku_metadata";
import JobLanding from "pages/ads_funnel/job_landing";
import JobQuiz from "pages/ads_funnel/job_quiz";
import JobInfo from "pages/ads_funnel/job_info";
import JobImpressum from "pages/ads_funnel/job_impressum";
import JobAgb from "pages/ads_funnel/job_agb";
import JobDatenschutz from "pages/ads_funnel/job_datenschutz";

class RenolitionApp extends Component {

  constructor(props) {
    super(props);

    this.setLoggedInEntityRole = (role) => {
      this.setState( { logged_in_entity_role: role } );
    };

    this.state = {
      logged_in_entity_role: null,
      setLoggedInEntityRole: this.setLoggedInEntityRole,
    }
  }

  render() {
    const isZoneaid = window.location.hostname.endsWith('zoneaid.io');

    if (isZoneaid) {
      return (
        <Router>
          <Switch>
            <Route path="/job" render={ props => <StandaloneContainer {...props} />} />
            <Redirect to="/job" />
          </Switch>
        </Router>
      );
    }

    return (
      <AuthContext.Provider value={ this.state }>
        <Router>
          <Switch>
            <Route path="/v1" render={ props => <QuoteContainer {...props} />} />
            <Route path="/job" render={ props => <StandaloneContainer {...props} />} />
            <Route render={ props => <DefaultContainer {...props} />} />
          </Switch>
        </Router>
      </AuthContext.Provider>
    );
  }
}

  const QuoteContainer = () => {
      return  <Switch>
                <Route path="/v1/code/intro" exact render={ props => <CodeLanding {...props} />} />
              </Switch>
  }

  const StandaloneContainer = () => {
      return (
        <div className="job-canvas">
          <style>{`
            .job-canvas {
              min-height: 100vh;
              background: #17293C;
            }
            @media (min-width: 500px) {
              .job-canvas > * {
                box-shadow: 0 0 60px rgba(0,0,0,.4);
              }
            }
          `}</style>
          <Switch>
            <Route path="/job" exact render={ props => <JobLanding {...props} />} />
            <Route path="/job/info" exact render={ props => <JobInfo {...props} />} />
            <Route path="/job/quiz" exact render={ props => <JobQuiz {...props} />} />
            <Route path="/job/impressum" exact render={ props => <JobImpressum {...props} />} />
            <Route path="/job/agb" exact render={ props => <JobAgb {...props} />} />
            <Route path="/job/datenschutz" exact render={ props => <JobDatenschutz {...props} />} />
          </Switch>
        </div>
      );
  }

  const DefaultContainer = () => {
      return <>
              <Authentication />
              <Header/>
              <ScrollToTop />
              <div class="mainContent">
                <Switch>
                    <Route path="/" exact render={ props => <IndexNew {...props} />} /> 
                    <Route path="/home" exact render={ props => <IndexNew {...props} />} /> 
                    {/* <Route path="/code/sf_search" exact render={ props => <SfPlanningSearch {...props} />} /> */}
                    <Route path="/v2/code/sf_search" exact render={ props => <SfPlanningSearchV2 {...props} />} />
                    <Route path="/code/oak_search" exact render={ props => <OakPlanningSearch {...props} />} />
                    <Route path="/code/jbk_search" exact render={ props => <JbkPlanningSearch {...props} />} />
                    
                    <Route path="/code/insights" exact render={ props => <SfPlanningInsights {...props} />} />
                    <Route path="/code/sf_detail/:id" exact render={ props => <SfPlanningDetail {...props} />} />
                    <Route path="/v2/code/sf_detail/:id" exact render={ props => <SfPlanningDetailV2 {...props} />} />
                    <Route path="/code/oak_detail/:id" exact render={ props => <OakPlanningDetail {...props} />} />
                    <Route path="/code/jbk_detail/:id" exact render={ props => <JbkPlanningDetail {...props} />} />

                    <Route path="/code/sign_up/:id" exact render={ props => <SignUp {...props} />} />

                    {/* <Route path="/code/oak_admin" exact render={ props => <OakPlanningAdmin {...props} />} />
                    <Route path="/code/sf_admin" exact render={ props => <SfPlanningAdmin {...props} />} />
                    <Route path="/code/jbk_admin" exact render={ props => <JbkPlanningAdmin {...props} />} /> */}

                    {/* <Route path="/code/code_parts" exact render={ props => <CodeParts {...props} />} />
                    <Route path="/code/code_labels" exact render={ props => <CodeLabels {...props} />} /> */}
                    
                    {/* <Route path="/code/code_tables" exact render={ props => <CodeTables {...props} />} />
                    <Route path="/code/code_sections" exact render={ props => <CodeSections {...props} />} />
                    <Route path="/code/code_zoning" exact render={ props => <CodeZoning {...props} />} />
                    <Route path="/code/code_search" exact render={ props => <CodeSearch {...props} />} /> */}

                    <Route path="/tos" exact render={ props => <TermsOfService {...props} />} /> 
                    <Route path="/video" exact render={ props => <Video {...props} />} /> 
                    <Route path="/tutorials" exact render={ props => <Tutorials {...props} />} /> 
                    <Route path="/sign_up_video" exact render={ props => <SignUpVideo {...props} />} /> 
                    <Route path="/privacy_policy" exact render={ props => <PrivacyPolicy {...props} />} /> 
                    <Route path="/about_us" exact render={ props => <AboutUs {...props} />} /> 
                    <Route path="/reviews" exact render={ props => <Review {...props} />} /> 
                    <Route path="/review/confirm_email/:id" exact render={ props => <ReviewEmailConfirmation {...props} />} /> 

                    <Route path="/account" exact render={ props => <Account {...props} />} /> 
                    <Route path="/login" exact render={ props => <Login {...props} />} />  
                    <Route path="/password_reset/:id" exact render={ props => <PasswordReset {...props} />} /> 

                    <Route path="/ads" exact render={ props => <AdsLanding {...props} />} /> 

                    <Route path="/agent/intro" exact render={ props => <AgentLanding {...props} />} />
                    <Route path="/agent/favorite_vendors" exact render={ props => <AgentFavoriteVendorList {...props} />} /> 
                    <Route path="/agent/contacts" exact render={ props => <AgentContacts {...props} />} /> 
    
                    <Route path="/agent/start" exact render={ props => <AgentIndex {...props} />} />
                    <Route path="/vendor_detail" exact render={ props => <VendorDetail {...props} />} />
                    <Route path="/agent" exact render={ props => <AgentIndex {...props} />} />
                    <Route path="/contact/start" exact render={ props => <ContactIndex {...props} />} />
                    <Route path="/contact/agent_vendors" exact render={ props => <ContactVendorList {...props} />} />
                    <Route path="/contact/vendor_discover" exact render={ props => <VendorDiscover {...props} />} />
                    <Route path="/contact/vendor_search" exact render={ props => <VendorSearch {...props} />} />
                    <Route path="/agent/vendor_review" exact render={ props => <VendorReview {...props} />} />
                    <Route path="/agent/agent_friends" exact render={ props => <AgentFriends {...props} />} />
                    <Route path="/agent/agent_search" exact render={ props => <AgentFriendsSearch {...props} />} />
                    <Route path="/agent/vendor_search" exact render={ props => <VendorSearch {...props} />} />
                    <Route path="/agent/vendor_discover" exact render={ props => <VendorDiscover {...props} />} />
                    <Route path="/agent/vetted_vendors" exact render={ props => <VettedVendors {...props} />} />
                    <Route path="/contact/:id" exact render={ props => <ContactLogin {...props} />} />

                    <Route path="/property_inspector" exact render={ props => <PropertyInspector {...props} />} />
                    <Route path="/gmail_import" exact render={ props => <GmailImport {...props} />} />

                    <Route path="/guides" exact render={ props => <Guides {...props} />} />
                    <Route path="/guides/kitchen_back_splash" exact render={ props => <ReplaceKitchenBacksplash {...props} />} />
                    <Route path="/guides/kitchen_appliances" exact render={ props => <ReplaceKitchenAppliances {...props} />} />
                    <Route path="/guides/kitchen_countertop" exact render={ props => <ReplaceKitchenCountertop {...props} />} />

                    <Route path="/vendor/plans/:id" exact render={ props => <VendorPlans {...props} />} />
                    <Route path="/vendor/start" exact render={ props => <VendorIndex {...props} />} />
                    <Route path="/vendor/account" exact render={ props => <VendorAccount {...props} />} />
                    <Route path="/vendor/vendor_search" exact render={ props => <VendorSearch {...props} />} />
                    <Route path="/vendor/vetted_vendors" exact render={ props => <VettedVendors {...props} />} />
                    <Route path="/vendor/requests" exact render={ props => <VendorRequests {...props} />} />
                    <Route path="/vendor/vendor_discover" exact render={ props => <VendorDiscover {...props} />} />
                    <Route path="/admin/permit" exact render={ props => <PermitsAdmin {...props} />} />

                    {/* AMZ */}
                    <Route path="/amz/sku_metadata_list" exact render={ props => <SkuMetadataList {...props} />} />
                    <Route path="/amz/sku_metadata" exact render={ props => <SkuMetadata {...props} />} />
                </Switch>
              </div>
            <Footer/>

            </>
  }

  export default RenolitionApp;